import React from 'react'
import { cn } from './cn'

export interface DropzoneProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 拖曳中以共用 emphasis surface 顯示接收狀態。 */
  dragging?: boolean
  /** 已有檔案時切成緊湊的「再加入」版本。 */
  compact?: boolean
}

/**
 * 拖放區容器：封裝 upload-modal 與 batch trial 兩處重複的外框、尺寸、拖放
 * 狀態與「已選檔案」緊湊版；檔案驗證/選取邏輯則維持在呼叫端。
 *
 * 範圍：僅樣式容器與 .drag 狀態。檔案驗證/選取邏輯（accept/maxFiles/onFiles）刻意
 * 不內建（兩頁的處理不同），留在呼叫端；內部 .dz-title/.dz-spec 維持頁面手寫。
 * forwardRef：batch 頁靠 ref/事件 target 判斷拖放命中。
 */
export const Dropzone = React.forwardRef<HTMLDivElement, DropzoneProps>(function Dropzone(
  { dragging, compact = false, className, ...rest },
  ref
) {
  return (
    <div
      ref={ref}
      data-dropzone
      data-compact={compact || undefined}
      className={cn(
        'rounded-[var(--radius-lg)] [border-width:var(--border-emphasis)] border-dashed border-border bg-background px-[var(--inset-dropzone-inline)] py-[var(--inset-dropzone-block)] text-center transition-[border-color_0.15s_ease,background_0.15s_ease] [&>.dz-title]:text-lg [&>.dz-title]:font-medium [&>.dz-title]:leading-[var(--leading-body)] [&>.dz-spec]:mt-[var(--gap-compact)] [&>button]:mt-[var(--gap-md)]',
        dragging && 'border-foreground bg-[var(--fg-soft)]',
        compact && 'px-[var(--gap-sm)] py-[var(--gap-compact)] [&>button]:mt-0',
        className
      )}
      {...rest}
    />
  )
})
